document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document.querySelectorAll(".header__menus--item")
  const HIDE_DELAY = 300 // Verzögerung in Millisekunden

  menuItems.forEach((item) => {
    const megaMenu = item.querySelector(".header__menus--megamenu")
    if (!megaMenu) return

    let timeoutId = null

    const showMenu = () => {
      clearTimeout(timeoutId)
      // Schließe alle anderen offenen Menüs, bevor ein neues geöffnet wird
      menuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("is-open")
        }
      })
      item.classList.add("is-open")
    }

    const hideMenu = () => {
      timeoutId = setTimeout(() => {
        item.classList.remove("is-open")
      }, HIDE_DELAY)
    }

    // Event-Listener für den Menüpunkt (z.B. "Handyhüllen")
    item.addEventListener("mouseenter", showMenu)
    item.addEventListener("mouseleave", hideMenu)

    // Event-Listener für das Mega-Menü selbst
    megaMenu.addEventListener("mouseenter", showMenu)
    megaMenu.addEventListener("mouseleave", hideMenu)
  })
})